var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
// helpers
import { getOmnitureMCID, getVisitorId, getBrowserNetworkSpeed, getBrowserNetworkType, removeEmptyKeys, } from './utils';
const commonFieldsMap = {
    environment: 'nykaa_environment',
    store: 'nykaa_store',
    platform: 'nykaa_platform',
    vertical: 'nykaa_vertical',
    customerId: 'nykaa_customer_id',
    deviceViewportHeight: 'device_screen_height',
    deviceViewportWidth: 'device_screen_width',
    networkSpeed: 'network_speed',
    networkWifi: 'network_wifi',
    omnitureMCID: 'omniture_mcid',
    visitorId: 'nykaa_visitor_id',
    sdkVersion: 'nykaa_sdk_version',
    appVersion: 'app_version',
};
let commonFields = {};
let omnitureMCID;
let visitorId;
let deviceViewportHeight;
let deviceViewportWidth;
let networkSpeed;
let networkWifi;
/**
 * Set Analytics common fields
 * @param {object} fields - common fields service would like to override or set
 */
export const setCommonFields = (_a) => {
    var fields = __rest(_a, []);
    const newCommonFields = Object.assign({}, commonFields);
    Object.keys(fields).forEach((fieldKey) => {
        const commonFieldKey = commonFieldsMap[fieldKey];
        newCommonFields[commonFieldKey] = fields[fieldKey];
    });
    commonFields = newCommonFields;
};
/**
 * Set cached / stored common fields
 * @param {object} cachedCommonFields - common fields stored in localStorage
 */
export const setCachedFields = (_a) => {
    var cachedCommonFields = __rest(_a, []);
    commonFields = Object.assign(Object.assign(Object.assign({}, cachedCommonFields), commonFields), removeEmptyKeys(commonFields));
};
/**
 * Get all the analytics common fields
 * @returns {object} commonFields
 */
export const getCommonFields = () => {
    if (omnitureMCID === undefined || !omnitureMCID) {
        omnitureMCID = getOmnitureMCID();
    }
    if (visitorId === undefined || !visitorId) {
        visitorId = `${getVisitorId()}`;
    }
    if (deviceViewportHeight === undefined || deviceViewportWidth === undefined) {
        deviceViewportHeight = window.innerHeight;
        deviceViewportWidth = window.innerWidth;
    }
    if (networkSpeed === undefined) {
        networkSpeed = getBrowserNetworkSpeed();
    }
    if (networkWifi === undefined) {
        networkWifi = getBrowserNetworkType();
    }
    return Object.assign({ [commonFieldsMap.omnitureMCID]: omnitureMCID, [commonFieldsMap.visitorId]: visitorId, [commonFieldsMap.deviceViewportHeight]: deviceViewportHeight, [commonFieldsMap.deviceViewportWidth]: deviceViewportWidth, [commonFieldsMap.networkSpeed]: networkSpeed !== 'NA' ? networkSpeed : undefined, [commonFieldsMap.networkWifi]: networkWifi !== 'NA' ? networkWifi === 'wifi' : undefined }, commonFields);
};
